export default (value) => {
  if (value) {
    return new Date(value.seconds*1000).toLocaleDateString(['en-US'], {month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})
  }
  return ''
}
